/**
 * Tiny logger util. In production builds (NODE_ENV=production) `warn` becomes
 * a no-op so we don't leak internal error messages / URLs into the browser
 * console. During dev + preview it still logs, which is where we actually need
 * to see the noise.
 */
const isProd = process.env.NODE_ENV === "production";

export const logger = {
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args) => {
    // Errors are always emitted — they're rare and materially useful.
    console.error(...args);
  },
};
